import { Stat } from '../../api';
import MonthBarChart from './MonthBarChart';

function getArrays(data: Stat, viewMode: string) {
  if (viewMode == 'transfer')
    return [
      data?.live?.jpg?.frame?.bytes
        ? data.live.jpg.frame.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
      data?.live?.jpg?.open?.bytes
        ? data.live.jpg.open.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
    ];
  else return data?.live?.jpg?.open?.count ? [data.live.jpg.open.count] : [[]];
}

function getTitle(viewMode: string, day: number): string {
  if (viewMode == 'transfer') return `Live JPG bandwidth usage (MB) by ${day ? 'hour' : 'day'}`;
  else return `Live JPG accesses by ${day ? 'hour' : 'day'}`;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getUnit(viewMode: string, day: number | undefined): string {
  if (viewMode == 'transfer') return 'MB';
  return 'accesses';
}

export default function MonthCameraLiveJpgChart(props: {
  stat: Stat;
  offset: number;
  daysInMonth: number;
  viewMode: string;
  day: number;
  month: number;
  year: number;
  tz: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
  onChangeDay: (d: number) => void;
}) {
  return <MonthBarChart getUnit={getUnit} getTitle={getTitle} getArrays={getArrays} {...props} />;
}
